<template>
  <div class="container mt-2">
    <b-modal
      ref="f4868ModalErrorCodes"
      title="Form 4868 Error Codes"
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <div v-for="(error, idx) in (!!toShow && !!toShow.efileErrorCodes && toShow.efileErrorCodes.entries || [])" class="mb-2">
            <b>{{error.ruleNum}}</b><br/>
            <span>{{error.errorMessageTxt}}</span>
          </div>
        </div>
      </div>
      <hr />
      <div>
        <button class="btn btn-outline-secondary" @click="closeForm4868ErrorCodesModal()">
          Cancel
        </button>
      </div>
    </b-modal>

    <Form4868Modal
      v-model="showForm4868Modal"
      :irsEnvironment="isProd ? 'P' : 'T'"
      @doRefresh="doRefresh"
    ></Form4868Modal>
    <Form9465Modal
      v-model="showForm9465Modal"
      :irsEnvironment="isProd ? 'P' : 'T'"
      @doRefresh="doRefresh"
    ></Form9465Modal>

    <div class="row mb-3 mt-4">
      <div class="col-4 col-md-2 pt-2">
        <toggle-button :width="40" :height="20" :font-size="18" v-model="isProd" color="#28a745"
          :sync="true" :labels="false" @change="atsProdChange" />
        <label>{{isProd ? "Production" : "ATS"}}</label>
      </div>
      <div class="col-4 col-md-2">
        <select
          class="form-control"
          v-model="formType">
          <option
            v-for="(type, i) in formTypes"
            :key="i"
            :value="type.value"
          >
            {{ type.name }}
          </option>
        </select>
      </div>
      <div class="col-4 col-md-2">
        <button
          class="btn btn-success float-left"
          style="min-width: 150px;"
          @click="onCreateForm()"
        >
          Create
        </button>
      </div>
    </div>
    <hr/>

    <div>
      <div class="inner-page-title mb-3 mt-4">
        e-File Submissions:
      </div>

      <div class="row">
        <div class="col-6 col-sm-3">
          <div class="form-group">
            <label> Form Type </label>
            <select class="form-control" v-model="request.query.type">
              <option value="ANY">Any</option>
              <option
                v-for="(type, i) in formTypes"
                :key="i"
                :value="type.value"
              >
                {{ type.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-6 col-sm-3">
          <div class="row">
            <div class="form-group col-6 select-status">
              <label> Status </label>
              <b-dropdown :style="{ width: '100%' }">
                <template slot="button-content">
                  Select
                  <font-awesome-icon
                    :icon="['fa', 'caret-down']"
                  ></font-awesome-icon>
                </template>
                <label class="d-block pl-4 pr-4">
                  <input
                    type="checkbox"
                    v-model="request.query.status.any"
                    @change="handleAnyStatusChange"
                  />
                  Any
                </label>

                <label class="d-block pl-4 pr-4">
                  <input
                    type="checkbox"
                    v-model="request.query.status.processing"
                    @change="handleStatusChange"
                  />
                  Processing
                </label>
                <label class="d-block pl-4 pr-4" style="width: 200px;">
                  <input
                    type="checkbox"
                    v-model="request.query.status.accepted"
                    @change="handleStatusChange"
                  />
                  Accepted
                </label>
                <label class="d-block pl-4 pr-4" style="width: 200px;">
                  <input
                    type="checkbox"
                    v-model="request.query.status.rejected"
                    @change="handleStatusChange"
                  />
                  Rejected
                </label>
                <label class="d-block pl-4 pr-4">
                  <input
                    type="checkbox"
                    v-model="request.query.status.exception"
                    @change="handleStatusChange"
                  />
                  Exception thrown
                </label>
                <label class="d-block pl-4 pr-4">
                  <input
                    type="checkbox"
                    v-model="request.query.status.ackResponse"
                    @change="handleStatusChange"
                  />
                  Ack Response Error
                </label>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-sm-3">
          <div class="form-group">
            <label> Time Period </label>
            <select
              class="form-control"
              v-model="request.query.dateRange"
              @change="handleDataRangeChange()"
            >
              <option value="TODAY">Today</option>
              <option value="YESTERDAY">Yesterday</option>
              <option value="SEVEN_DAYS">Last 7 Days</option>
              <option value="THIRTY_DAYS">Last 30 Days</option>
              <option value="ALL">ALL</option>
              <option value="CUSTOM">CUSTOM</option>
            </select>
          </div>
        </div>
        <div class="col-6 col-sm-3">
          <div class="form-group select-date">
            <input
              placeholder="Select Date"
              class="form-control"
              id="formSearchDates"
              :value="
                formatDates(
                  request.query.startAt,
                  request.query.endAt
                )
              "
              :disabled="request.query.dateRange !== 'CUSTOM'"
            />
            <span
              id="cleardates"
              @click="clearDates()"
              :disabled="request.query.dateRange !== 'CUSTOM'"
              >X</span
            >
            <AirbnbStyleDatepicker
              style="position: absolute; width: 350px; left: 15px; top: 72px;"
              :showShortcutsMenuTrigger="false"
              :trigger-element-id="'formSearchDates'"
              :monthsToShow="1"
              :mode="'range'"
              :fullscreen-mobile="false"
              :date-one="request.query.startAt"
              :date-two="request.query.endAt"
              @date-one-selected="
                (val) => {
                  request.query.startAt = val;
                }
              "
              @date-two-selected="
                (val) => {
                  request.query.endAt = val;
                }
              "
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-sm">
          <button
            class="btn btn-secondary"
            style="z-index: 2;"
            @click="resetSearch()"
          >
            Search
          </button>
        </div>
      </div>

      <h6 class="mt-4">Results ({{ searchResult.numResults }})</h6>
      <div class="text-center">
        <span v-for="(page, idx) in pages" :key="idx">
          <span class="btn" v-if="page.current">{{ page.pageNumber + 1 }}</span>
          <button class="btn btn-link" href="#" v-else @click="loadPage(page)">
            {{ page.pageNumber + 1 }}
          </button>
        </span>
      </div>

      <div class="mt-4"></div>

      <div class="row" v-if="searchResult.rows.length === 0">
        <div class="col">
          <div class="font-weight-bold">No orders match the given criteria.</div>
        </div>
      </div>

      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Submission #</th>
            <th>Status</th>
            <th>User Data</th>
            <th>Submission Data</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(submission, idx) in searchResult.rows"
            :key="idx"
            :style="styleForStatus(submission.efileStatus)"
          >
            <td>
              {{ submission.createdDate }}
            </td>
            <td>
              {{ submission.id }} <b style="color:black">{{ submission.irsEnvironment == 'P' ? "Production" : "ATS" }}</b>
              <br/>
              Type: <i>{{ getFormType(submission.type) }}</i>
            </td>
            <td>{{ submission.efileStatus }}</td>
            <td>
              {{ submission.firstName + ' ' + submission.lastName }}</br>
              {{ submission.phone }}
            </td>
            <td>
              <div v-if="!!submission.efileSubmissionId">
                <span>
                  Submission ID: <b>
                    {{submission.efileSubmissionId}}
                  </b>
                </span><br/>
                <span>
                  Status: <b :style="submission.efileStatus == 'Accepted' ? 'color: green;' : 'color: red;'">
                    {{submission.efileStatus}}
                  </b>
                </span>

                <div class="d-flex">
                  <div
                    style="color: #2e85f5; cursor: pointer"
                    @click="downloadSubmissionXML(submission)">
                    <u><b>submission_{{submission.id}}.xml</b></u>
                  </div>
                </div>
                <div class="d-flex mb-2">
                  <div
                    style="color: #2e85f5; cursor: pointer"
                    @click="downloadManifestXML(submission)">
                    <u><b>manifest_{{submission.id}}.xml</b></u>
                  </div>
                </div>

                <div v-if="!!submission.efileAckResponse">
                  <div class="d-flex" v-if="!!submission.efileErrorCodes && !!submission.efileErrorCodes.entries && submission.efileErrorCodes.entries.length > 0">
                    <span>
                      Error Codes: <a
                         style="color: #2e85f5; cursor: pointer"
                         @click="onForm4868ErrorCodes(submission)">
                         <b>{{form4868ErrorCodesLabel(submission)}}</b>
                       </a>
                    </span>
                  </div>

                  <div class="d-flex mt-2">
                    <div
                      style="color: #2e85f5; cursor: pointer"
                      @click="downloadAckResponseXML(submission)">
                      <u><b>ack_response_{{submission.id}}.xml</b></u>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <button
                class="btn btn-secondary"
                @click="openSubmissionDetails(submission)"
              >
                Details
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col text-center">
          <span v-for="(page, idx) in pages" :key="idx" class="p-2">
            <span v-if="page.current">{{ page.pageNumber + 1 }}</span>
            <button class="btn btn-link" href="#" v-else @click="loadPage(page)">
              {{ page.pageNumber + 1 }}
            </button>
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { AXIOS } from '../scripts/http-common';
import moment from "moment-timezone";
import { SiteUtils } from "../scripts/site-common";
import Datepicker from "vuejs-datepicker";
import format from "date-fns/format";

export default {
    name: 'EFileTab',
    components: {
      Form4868Modal: () => import('./efile/Form4868Modal.vue'),
      Form9465Modal: () => import('./efile/Form9465Modal.vue'),
      Datepicker,
    },
    data() {
        return {
            // Form submission section:
            isProd: window.isProduction,
            formTypes: [{name: "Form 4868", value: "FORM_4868"}, {name: "Form 9465", value: "FORM_9465"}],
            formType: "FORM_4868",

            // Child modals:
            showForm4868Modal: false,
            showForm9465Modal: false,

            // Display forms table section:
            toShow: {},

            request: {
              pageNumber: 0,
              pageSize: 10,
              query: {
                type: "ANY",

                dateRange: "THIRTY_DAYS",
                startAt: "",
                endAt: "",

                status: {
                  any: true,
                  processing: false,
                  accepted: false,
                  rejected: false,
                  exception: false,
                  ackResponse: false,
                },
              },
            },
            searchResult: {
              numResults: 0,
              resultsInPage: 0,
              rows: [],
            },
            pages: [
              {
                pageNumber: 0,
                current: true,
              },
            ],
        }
    },
    mounted() {
        this.searchForms();
    },
    methods: {
        loadPage(page) {
          this.request.pageNumber = page.pageNumber;
          this.searchForms();
        },
        handleStatusChange() {
          this.request.query.status.any = false;
        },
        handleAnyStatusChange() {
          if (this.request.query.status.any) {
            this.request.query.status.processing = false;
            this.request.query.status.accepted = false;
            this.request.query.status.rejected = false;
            this.request.query.status.exception = false;
            this.request.query.status.ackResponse = false;
          }
        },
        resetSearch() {
          this.request.pageNumber = 0;
          // TODO: Add logic with store
          this.searchForms();
        },

        formatDates(dateOne, dateTwo) {
          let formattedDates = "";
          if (dateOne) {
            formattedDates = format(dateOne, "MM/DD/YYYY");
          }
          if (dateTwo) {
            formattedDates += " - " + format(dateTwo, "MM/DD/YYYY");
          }
          return formattedDates;
        },
        handleDataRangeChange() {
          if (this.request.query.dateRange !== "CUSTOM") {
            this.request.query.startAt = "";
            this.request.query.endAt = "";
          }
        },
        clearDates() {
          (this.request.query.startAt = ""), (this.request.query.endAt = "");
        },

        styleForStatus(efileStatus) {
          if (['Rejected', 'Exception thrown', 'Ack Response Error'].includes(efileStatus)) {
            return 'background-color: #FFEDED';
          }
          if (['Accepted'].includes(efileStatus)) {
            return 'background-color: #E6FAE6';
          }
          return 'background-color: #FFFFFF';
        },
        getFormType(type) {
          if (type == "FORM_9465") {
            return "Form 9465";
          }
          return "Form 4868";
        },

        atsProdChange(value) {
            if (!window.isProduction) {
              alert('Only ATS submissions allowed on staging environment');
              this.isProd = false;
              value.srcEvent.preventDefault();
            }
        },
        onCreateForm() {
          this.showForm4868Modal = this.formType === "FORM_4868";
          this.showForm9465Modal = this.formType === "FORM_9465";
        },

        onClickRefresh() {
          this.searchForms();
        },
        doRefresh() {
          this.searchForms();
        },
        openSubmissionDetails(submission) {
          if (submission.type == "FORM_9465") {
            this.$router.push(`/admin/submission/form9465/${submission.id}`);
          } else {
            this.$router.push(`/admin/submission/form4868/${submission.id}`);
          }
        },

        searchForms() {
            if (this.request.query.dateRange == "TODAY") {
              this.request.query.startAt = moment().format("YYYY-MM-DD");
              this.request.query.endAt = moment().format("YYYY-MM-DD");
            } else if (this.request.query.dateRange == "YESTERDAY") {
              this.request.query.startAt = moment().subtract(1, "days").format("YYYY-MM-DD");
              this.request.query.endAt = moment().subtract(1, "days").format("YYYY-MM-DD");
            } else if (this.request.query.dateRange == "SEVEN_DAYS") {
              this.request.query.startAt = moment().subtract(7, "days").format("YYYY-MM-DD");
              this.request.query.endAt = moment().format("YYYY-MM-DD");
            } else if (this.request.query.dateRange == "THIRTY_DAYS") {
              this.request.query.startAt = moment().subtract(30, "days").format("YYYY-MM-DD");
              this.request.query.endAt = moment().format("YYYY-MM-DD");
            }

            let statuses = [];
            if (this.request.query.status.any) {
              statuses = ["Processing", "Accepted", "Rejected", "Exception thrown", "Ack Response Error"];
            } else {
              if (this.request.query.status.processing) statuses.push("Processing");
              if (this.request.query.status.accepted) statuses.push("Accepted");
              if (this.request.query.status.rejected) statuses.push("Rejected");
              if (this.request.query.status.exception) statuses.push("Exception thrown");
              if (this.request.query.status.ackResponse) statuses.push("Ack Response Error");
            }

            let request = {
              type: this.request.query.type,
              statuses: statuses.join(","),

              startAt: this.request.query.startAt,
              endAt: this.request.query.endAt,

              pageNumber: this.request.pageNumber,
              pageSize: this.request.pageSize
            };
            AXIOS.post(`/admin/efile/submission/list`, request).then(res => {
                if (res.status == 200) {
                    this.$set(this, "searchResult", res.data);
                    let numPages = this.searchResult.numResults / this.searchResult.pageSize;
                    this.pages = [];
                    for (let i = 0; i < numPages; i++) {
                      this.pages.push({
                        pageNumber: i,
                        current: i === this.searchResult.pageNumber,
                      });
                    }
                }
            }).catch(err => {
                alert('Error occurred while loading forms list');
                console.log(err);
                this.$router.push('/login');
            });
        },
        downloadSubmissionXML(submission) {
          if (submission.type == "FORM_9465") {
            window.location = "/api/admin/efile/submission/f9465/xml/submission/" + submission.id;
          } else {
            window.location = "/api/admin/efile/submission/f4868/xml/submission/" + submission.id;
          }
        },
        downloadManifestXML(submission) {
          if (submission.type == "FORM_9465") {
            window.location = "/api/admin/efile/submission/f9465/xml/manifest/" + submission.id;
          } else {
            window.location = "/api/admin/efile/submission/f4868/xml/manifest/" + submission.id;
          }
        },
        downloadAckResponseXML(submission) {
          if (submission.type == "FORM_9465") {
            window.location = "/api/admin/efile/submission/f9465/xml/ack_response/" + submission.id;
          } else {
            window.location = "/api/admin/efile/submission/f4868/xml/ack_response/" + submission.id;
          }
        },

        form4868ErrorCodesLabel(order) {
          let errors = order.efileErrorCodes;
          if (!errors) {
            return "";
          }
          errors = errors.entries;
          if (!errors || errors.length == 0) {
            return "";
          }

          if (errors.length == 1) {
            return errors[0].ruleNum;
          }
          if (errors.length == 2) {
            return errors[0].ruleNum + ", " + errors[1].ruleNum;
          }
          return errors[0].ruleNum + ", " + (errors.length - 1) + " others"
        },
        onForm4868ErrorCodes(order) {
          this.toShow = order;
          this.$refs.f4868ModalErrorCodes.show();
        },
        closeForm4868ErrorCodesModal() {
          this.toShow = {};
          this.$refs.f4868ModalErrorCodes.hide();
        },
    }
}
</script>

<style>
.admin-controls-table th, td {
    font-family: "Archivo", sans-serif;
    border-top: none!important;
}

.table th {
    border-top: none;
}

table.admin-controls-table td {
    vertical-align: middle !important;
}

.button-wrap {
    text-align: right;
}

#cleardates {
  position: absolute;
  right: 5%;
  top: 12%;
  cursor: pointer;
  color: darkgrey;
}
.select-date {
  padding-right: 0;
}
.select-date #formSearchDates {
  margin-top: 32px;
  border-radius: 999px;
}
.select-date #cleardates {
  top: 46%;
  right: 9%;
}
.select-status {
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/EFileTab.vue